export interface IMeasurementModesDisp {
    [key: string]: IMeasurementDisp;
}

export interface IMeasurementDisp {
    distanceShort: string;
    distance: string;
    speed: string;
}


export const measurementModesDisp: IMeasurementModesDisp = {
    metric: {
        distanceShort: "m",
        distance: "km",
        speed: "km/h"
    },
    imperial: {
        distanceShort: "ft",
        distance: "mi",
        speed: "mph"
    }
};
